<div
  class="step-progress d-flex flex-column flex-md-row justify-content-md-around align-items-md-end"
>
  <ng-content select="app-step-progress-step"></ng-content>
</div>
